import { StdResponse, request } from "@/global/config/request";
import { Position } from "@/global/interface/project-manage/position";


export function getPositions(params?: {}): Promise<StdResponse<any>> {
    return request.get(`/positions`, {
        params: {
            ...params,
        }
    })
}

export function createPosition(data: Position, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/positions`, data, {
        params: {
            ...params,
        }
    })
}

export function getPositionDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/positions/${id}`, {
        params: {
            ...params,
        }
    })
}

export function updatePosition(id: number, data: Position, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/positions/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function updatePositionAuth(id: number, auth: number, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/positions/auths`, null, {
        params: {
            ...params,
            id: id,
            auth: auth,
        }
    })
}

export function deletePosition(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/positions/${id}`, {
        params: {
            ...params,
        }
    })
}